import { SUPPLIER_QUOTE_REQUEST_CONTENT_TYPE_ID } from "@grafit/shared/domain/supplier-quote-request/supplier-quote-request-content";
import { isTypeId, parseTypeId } from "@grafit/shared/utils/typeid";
import { createFileRoute } from "@tanstack/react-router";
import { ConsultationVersionedProjectGuard } from "../../../../features/supplier-quote-request/consultation-version-guard";
import { SupplierQuoteRequestContentRoutePage } from "../../../../pages/supplier-quote-request-content-page/supplier-quote-request-content-route-page";
import { notFound } from "../../../../scaffolding/router-api";

export const Route = createFileRoute(
  "/_auth/_project/supplier-quote-request/$projectId/$subProjectId/content/$contentId",
)({
  beforeLoad: ({ params }) => {
    if (!isTypeId(params.contentId, SUPPLIER_QUOTE_REQUEST_CONTENT_TYPE_ID)) {
      throw notFound();
    }
    return { contentId: parseTypeId(params.contentId, SUPPLIER_QUOTE_REQUEST_CONTENT_TYPE_ID) };
  },
  component: () => (
    <ConsultationVersionedProjectGuard>
      <SupplierQuoteRequestContentRoutePage />
    </ConsultationVersionedProjectGuard>
  ),
});
